module.exports = __webpack_public_path__ + "88a393088a0d6c1f431ac1bf403fb91a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/caret.svg
// module id = 329
// module chunks = 0